import { render } from "./WQaddlook.vue?vue&type=template&id=152e8cbb&scoped=true"
import script from "./WQaddlook.vue?vue&type=script&lang=js"
export * from "./WQaddlook.vue?vue&type=script&lang=js"

import "./WQaddlook.vue?vue&type=style&index=0&id=152e8cbb&lang=scss&scoped=true"
import "./WQaddlook.vue?vue&type=style&index=1&id=152e8cbb&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152e8cbb"]])

export default __exports__